import React from "react";
import { useTranslation } from "react-i18next";

import style from "./styles.module.scss";

interface Props {
  active: boolean;
}

export default function StatusTag({ active }: Props) {
  const { t } = useTranslation();

  return (
    <span className={`pgm-label-large ${style.tag} ${active ? style.tagActive : style.tagInactive}`}>
      <span aria-hidden="true" className={style.tagDot} />
      {t(`translations.admin.users.status.${active ? "active" : "inactive"}`)}
    </span>
  );
}
